import React from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import Swal from "sweetalert2";
import {
  Button,
  Card,
  Form,
  Col,
  Modal,
  Tab,
  Row,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { tambahMarketing } from "stores";
import { getAllMarketing } from "stores";
import { getAllClient } from "stores";
import { getAllCabang } from "stores";
import { penempatanMarketing } from "stores";
import { editStatusMarketing } from "stores";
import moment from "moment";
import { resetPassword } from "stores";
import { tambahAksesUser } from "stores";
import { hapusAksesUser } from "stores";

function ListMarketing() {
  const dispatch = useDispatch();
  const marketing = useSelector((state) => state.marketingReducer);
  const storeClient = useSelector((state) => state.clientReducer);
  const storeCabang = useSelector((state) => state.cabangReducer);
  const auth = useSelector((state) => state.authReducer);
  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 10;
  const [salesMarketing, setSalesMarketing] = React.useState(false);
  const [modalPenempatan, setModalPenempatan] = React.useState(false);
  const [modalEdit, setModalEdit] = React.useState(false);
  const [modalDetail, setModalDetail] = React.useState(false);
  const [modalUbahPenempatan, setModalUbahPenempatan] = React.useState(false);
  const [pilihClient, setPilihClient] = React.useState(null);
  const [pilihRole, setPilihRole] = React.useState(null);
  const [role, setRole] = React.useState("");
  const [nik, setNik] = React.useState("");
  const [nama, setNama] = React.useState("");
  const [nopeg, setNopeg] = React.useState("");
  const [listClient, setListClient] = React.useState([]);
  const [listMarketing, setListMarketing] = React.useState([]);
  const [idClient, setIdClient] = React.useState("");
  const [pilihCabang, setPilihCabang] = React.useState(null);
  const [listCabang, setListCabang] = React.useState([]);
  const [idCabang, setIdCabang] = React.useState(null);
  const [idMarketing, setIdMarketing] = React.useState("");
  const [status, setStatus] = React.useState("");
  const [searchText, setSearchText] = React.useState("");
  const [pilihAkses, setPilihAkses] = React.useState("");
  const [aksesUser, setAksesUser] = React.useState("");
  const [modalTambahAkses, setModalTambahAkses] = React.useState(false);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleNikChange = (e) => {
    const inputNik = e.target.value;
    const formattedNik = inputNik.slice(0, 16);
    setNik(formattedNik);
  };

  const remainingDigits = 16 - nik.length;

  const submitMarketing = () => {
    if (nik.length < 16) {
      Swal.fire({
        title: "NIK harus 16 digit !!",
        icon: "warning",
      });
      return;
    }

    tambahMarketing({
      nik: nik,
      nama: nama,
      nopeg: nopeg,
      role: role,
      idClient: idClient,
    })
      .then((response) => {
        if (response.data.status === 200) {
          const newPassword = response.data.defaultPassword;

          // STEP 1: Tutup modal form input Marketing terlebih dahulu
          handleModalClose();
          if (typeof setModalMarketing === "function") {
            setModalMarketing(false); // Sesuaikan dengan nama state penutup modal Marketing milikmu
          }

          // STEP 2: Beri jeda 250ms agar transisi hilangnya modal Bootstrap berjalan mulus
          setTimeout(() => {
            // STEP 3: Tampilkan SweetAlert besar dengan proteksi tombol konfirmasi terkunci
            Swal.fire({
              title: "⚠️ PENTING: SIMPAN PASSWORD INI!",
              icon: "success",
              width: "700px", // Memperbesar ukuran jendela popup agar dominan di layar
              confirmButtonColor: "#1D3557",
              confirmButtonText: "Saya Sudah Menyalin & Selesai",
              allowOutsideClick: false, // Mencegah penutupan modal tak sengaja dengan mengklik backdrop
              html: `
              <div style="text-align: left; background-color: #fffbeb; padding: 20px; border: 2px solid #fef3c7; border-radius: 12px; margin-top: 15px;">
                <p style="margin-bottom: 12px; color: #b45309; font-size: 15px; font-weight: 600; line-height: 1.5;">
                  Akun Marketing berhasil dibuat! Kredensial ini <span style="color: #dc2626; font-weight: 800;">HANYA MUNCUL SEKALI</span>. 
                  Silakan klik tombol <strong>Copy</strong> untuk mengaktifkan tombol selesai:
                </p>
                
                <div style="display: flex; align-items: center; justify-content: space-between; background: white; padding: 14px 20px; border: 2px solid #1D3557; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.05);">
                  <code id="raw-password" style="font-size: 20px; font-weight: 800; color: #1d3557; letter-spacing: 0.5px;">${newPassword}</code>
                  <button 
                    id="btn-copy-pass"
                    type="button"
                    style="background: #1D3557; color: white; border: none; padding: 8px 16px; border-radius: 6px; cursor: pointer; font-size: 14px; font-weight: 700; transition: all 0.2s ease; min-width: 80px;"
                  >
                    Copy
                  </button>
                </div>
              </div>
              <div id="copy-warning-text" style="display: flex; align-items: center; justify-content: center; gap: 8px; margin-top: 15px; color: #dc2626; font-size: 13px; font-weight: 700;">
                <i class="fas fa-lock"></i>
                <span>Tombol konfirmasi terkunci! Silakan salin password terlebih dahulu.</span>
              </div>
            `,
              didOpen: () => {
                const confirmBtn = Swal.getConfirmButton();
                const copyBtn = document.getElementById("btn-copy-pass");
                const warningText =
                  document.getElementById("copy-warning-text");

                // Kunci tombol konfirmasi utama saat modal terbuka pertama kali
                if (confirmBtn) {
                  confirmBtn.disabled = true;
                  confirmBtn.style.opacity = "0.5";
                  confirmBtn.style.cursor = "not-allowed";
                }

                if (copyBtn) {
                  copyBtn.addEventListener("click", () => {
                    // Proses salin password ke clipboard internal perangkat
                    navigator.clipboard.writeText(newPassword);

                    // Perbarui visual tombol copy
                    copyBtn.innerText = "Copied!";
                    copyBtn.style.backgroundColor = "#10B981";

                    // Buka gembok tombol konfirmasi utama setelah berhasil disalin
                    if (confirmBtn) {
                      confirmBtn.disabled = false;
                      confirmBtn.style.opacity = "1";
                      confirmBtn.style.cursor = "pointer";
                    }

                    // Ubah indikator teks peringatan di bawah box menjadi sukses (hijau)
                    if (warningText) {
                      warningText.style.color = "#10B981";
                      warningText.innerHTML = `<i class="fas fa-check-circle"></i> <span>Password berhasil disalin! Anda sekarang dapat menutup jendela ini.</span>`;
                    }
                  });
                }
              },
            }).then((result) => {
              // STEP 4: Setelah Admin selesai menyalin dan menutup Swal, barulah data tabel di background disegarkan
              if (result.isConfirmed || result.isDismissed) {
                getAllMarketing(dispatch, { idClient: "" });
              }
            });
          }, 250);
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message || "Terjadi kesalahan",
          });
        }
      })
      .catch((error) => {
        console.log("ERRORRRR", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text:
            error.response?.data?.message || "Terjadi kesalahan pada sistem.",
        });
      });
  };

  const checkStatus = () => {
    if (status.value === undefined || status === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Status wajib diisi !",
      });
    } else {
      submitEditStatus();
    }
  };

  const submitEditStatus = () => {
    editStatusMarketing({
      idMarketing: idMarketing,
      status: status.value,
    })
      .then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          getAllMarketing(dispatch, { idClient: "" });
          setModalEdit(false);
          setStatus("");
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message,
        });
      });
  };

  const submitPenempatan = () => {
    if (pilihCabang === null) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Pemilihan Cabang tidak boleh kosong",
      });
    } else {
      penempatanMarketing({
        idMarketing: idMarketing,
        idCabang: idCabang,
      }).then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          handleModalClose();
          setIdCabang("");
          setPilihCabang("");
          getAllMarketing(dispatch, { idClient: "" });
        } else if (response.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      });
    }
  };

  const submitUbahPenempatan = () => {
    if (pilihCabang === null) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Pemilihan Cabang tidak boleh kosong",
      });
    } else {
      penempatanMarketing({
        idMarketing: idMarketing,
        idCabang: idCabang,
      }).then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          handleModalClose();
          setIdCabang(null);
          setPilihCabang(null);
          getAllMarketing(dispatch, { idClient: "" });
        } else if (response.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      });
    }
  };

  const submitTambahAksesUser = () => {
    if (!pilihAkses) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Pemilihan akses tidak boleh kosong",
      });
    } else {
      tambahAksesUser({
        idMarketing: idMarketing,
        kategoriMarketing: pilihAkses.value,
      }).then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          handleModalClose();
          // setIdCabang("");
          // setPilihCabang("");
          getAllMarketing(dispatch, { idClient: "" });
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      });
    }
  };

  const listAkses = [
    { value: "", isDisabled: true },
    { label: "Konvensional", value: "konvensional" },
    { label: "Syariah", value: "syariah" },
  ];

  const handleModalClose = () => {
    setPilihCabang(null);
    setIdCabang(null);
    setPilihRole(null);
    setRole("");
    setPilihClient(null);
    setSalesMarketing(false);
    setModalPenempatan(false);
    setModalUbahPenempatan(false);
    setNik("");
    setNopeg("");
    setNama("");
    setModalTambahAkses(false);
    setPilihAkses("");
  };

  React.useEffect(() => {
    let tmp =
      marketing.listMarketing &&
      marketing.listMarketing.map((val) => {
        const ubahPenempatan = val.penempatan != "";
        const isAktif = val.status === "aktif";

        return {
          ...val,
          action: (
            <div className="d-flex justify-content-center align-items-center flex-wrap">
              {/* 1. BUTTON PENEMPATAN / UBAH PENEMPATAN */}
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip>
                    {ubahPenempatan
                      ? "Ubah Penempatan"
                      : "Penempatan Marketing"}
                  </Tooltip>
                }
              >
                <Button
                  disabled={!ubahPenempatan && !isAktif}
                  className="btn-icon mx-1 shadow-sm d-flex align-items-center justify-content-center"
                  style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "10px",
                    backgroundColor: ubahPenempatan
                      ? "#FFB020"
                      : isAktif
                        ? "#447DF7"
                        : "#E2E8F0",
                    border: "none",
                    color: ubahPenempatan || isAktif ? "white" : "#94A3B8",
                    marginTop: "5px",
                    marginBottom: "5px",
                    transition: "all 0.2s ease",
                  }}
                  onClick={() => {
                    setIdMarketing(val._id);
                    getAllCabang(dispatch, { idClient: val.idClient });
                    ubahPenempatan
                      ? setModalUbahPenempatan(!modalUbahPenempatan)
                      : setModalPenempatan(!modalPenempatan);
                  }}
                >
                  <i
                    className="fas fa-map-marked-alt"
                    style={{ fontSize: "15px" }}
                  ></i>
                </Button>
              </OverlayTrigger>

              {/* 2. BUTTON TAMBAH AKSES (SUPER ADMIN / ADMIN) */}
              {(auth.role === "super admin" || auth.role === "admin") && (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Tambah Akses</Tooltip>}
                >
                  <Button
                    className="btn-icon mx-1 shadow-sm d-flex align-items-center justify-content-center"
                    style={{
                      width: "36px",
                      height: "36px",
                      borderRadius: "10px",
                      backgroundColor: "#BD16DF",
                      border: "none",
                      color: "white",
                      marginTop: "5px",
                      marginBottom: "5px",
                    }}
                    onClick={() => {
                      setIdMarketing(val._id);
                      setModalTambahAkses(!modalTambahAkses);
                      setAksesUser(val.kategoriMarketing);
                    }}
                  >
                    <i
                      className="fas fa-user-lock"
                      style={{ fontSize: "15px" }}
                    ></i>
                  </Button>
                </OverlayTrigger>
              )}

              {/* 3. BUTTON EDIT STATUS */}
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Edit Status</Tooltip>}
              >
                <Button
                  className="btn-icon mx-1 shadow-sm d-flex align-items-center justify-content-center"
                  style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "10px",
                    backgroundColor: "#76CD26",
                    border: "none",
                    color: "white",
                    marginTop: "5px",
                    marginBottom: "5px",
                  }}
                  onClick={() => {
                    setIdMarketing(val._id);
                    setModalEdit(!modalEdit);
                  }}
                >
                  <i
                    className="fas fa-user-edit"
                    style={{ fontSize: "15px" }}
                  ></i>
                </Button>
              </OverlayTrigger>

              {/* 4. BUTTON RESET PASSWORD */}
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Reset Password</Tooltip>}
              >
                <Button
                  className="btn-icon mx-1 shadow-sm d-flex align-items-center justify-content-center"
                  style={{
                    width: "38px",
                    height: "38px",
                    borderRadius: "10px",
                    backgroundColor: "#F87171",
                    border: "none",
                    color: "white",
                    transition: "all 0.2s ease",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.backgroundColor = "#EF4444")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.backgroundColor = "#F87171")
                  }
                  onClick={async () => {
                    const result = await Swal.fire({
                      title: "Reset Password",
                      text: `Apakah Anda yakin ingin mereset password pengguna ${val.nama}?`,
                      icon: "warning",
                      showCancelButton: true,
                      confirmButtonColor: "#1D3557",
                      cancelButtonColor: "#d33",
                      confirmButtonText: "Ya, Reset Password!",
                    });

                    if (result.isConfirmed) {
                      try {
                        // 1. Panggil API reset password
                        const response = await resetPassword({
                          idUser: val._id,
                          role: val.role,
                        });

                        // 2. Ambil password plain text dari response backend kamu
                        const newPassword = response.data.defaultPassword;

                        // 3. Tampilkan SweetAlert Sukses berukuran besar dengan tombol konfirmasi terkunci
                        Swal.fire({
                          title: "⚠️ PENTING: SIMPAN PASSWORD INI!",
                          icon: "success",
                          width: "700px", // Membuat ukuran pop-up lebih besar dan dominan
                          confirmButtonColor: "#1D3557",
                          confirmButtonText: "Saya Sudah Menyalin & Selesai",
                          allowOutsideClick: false, // Mencegah admin tidak sengaja klik luar modal
                          html: `
                                                  <div style="text-align: left; background-color: #fffbeb; padding: 20px; border: 2px solid #fef3c7; border-radius: 12px; margin-top: 15px;">
                                                    <p style="margin-bottom: 12px; color: #b45309; font-size: 15px; font-weight: 600; line-height: 1.5;">
                                                      Password berhasil direset! Sistem telah men-hash password baru ini demi keamanan. 
                                                      <br><span style="color: #dc2626; font-weight: 800;">Kredensial ini HANYA MUNCUL SEKALI</span>. 
                                                      Silakan klik tombol <strong>Copy</strong> untuk mengaktifkan tombol selesai:
                                                    </p>
                                                    
                                                    <div style="display: flex; align-items: center; justify-content: space-between; background: white; padding: 14px 20px; border: 2px solid #1D3557; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.05);">
                                                      <code id="raw-password" style="font-size: 20px; font-weight: 800; color: #1d3557; letter-spacing: 0.5px;">${newPassword}</code>
                                                      <button 
                                                        id="btn-copy-pass"
                                                        type="button"
                                                        style="background: #1D3557; color: white; border: none; padding: 8px 16px; border-radius: 6px; cursor: pointer; font-size: 14px; font-weight: 700; transition: all 0.2s ease; min-width: 80px;"
                                                      >
                                                        Copy
                                                      </button>
                                                    </div>
                                                  </div>
                                                  <div id="copy-warning-text" style="display: flex; align-items: center; justify-content: center; gap: 8px; margin-top: 15px; color: #dc2626; font-size: 13px; font-weight: 700;">
                                                    <i class="fas fa-lock"></i>
                                                    <span>Tombol konfirmasi terkunci! Silakan salin password terlebih dahulu.</span>
                                                  </div>
                                                `,
                          didOpen: () => {
                            const confirmBtn = Swal.getConfirmButton();
                            const copyBtn =
                              document.getElementById("btn-copy-pass");
                            const warningText =
                              document.getElementById("copy-warning-text");

                            // Secara default, kunci tombol konfirmasi utama
                            if (confirmBtn) {
                              confirmBtn.disabled = true;
                              confirmBtn.style.opacity = "0.5";
                              confirmBtn.style.cursor = "not-allowed";
                            }

                            if (copyBtn) {
                              copyBtn.addEventListener("click", () => {
                                // Proses copy teks password ke clipboard
                                navigator.clipboard.writeText(newPassword);

                                // Modifikasi tombol copy menjadi sukses
                                copyBtn.innerText = "Copied!";
                                copyBtn.style.backgroundColor = "#10B981";

                                // Buka kunci tombol konfirmasi utama setelah berhasil di-copy
                                if (confirmBtn) {
                                  confirmBtn.disabled = false;
                                  confirmBtn.style.opacity = "1";
                                  confirmBtn.style.cursor = "pointer";
                                }

                                // Ubah teks peringatan di bawah box menjadi hijau/aman
                                if (warningText) {
                                  warningText.style.color = "#10B981";
                                  warningText.innerHTML = `<i class="fas fa-check-circle"></i> <span>Password berhasil disalin! Anda sekarang dapat menutup jendela ini.</span>`;
                                }
                              });
                            }
                          },
                        });
                      } catch (error) {
                        Swal.fire({
                          title: "Error",
                          text:
                            error.response?.data?.message ||
                            "Terjadi kesalahan pada sistem.",
                          icon: "error",
                        });
                      }
                    }
                  }}
                >
                  <i className="fas fa-key" style={{ fontSize: "15px" }}></i>
                </Button>
              </OverlayTrigger>
            </div>
          ),
        };
      });
    setListMarketing(tmp);
  }, [marketing.listMarketing, auth]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeCabang.listCabang &&
      storeCabang.listCabang.map((val) => {
        tmp.push({
          value: val._id,
          label: val.namaCabang,
        });
      });

    setListCabang(tmp);
  }, [storeCabang.listCabang]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeClient.listClient &&
      storeClient.listClient.map((val) => {
        tmp.push({
          value: val._id,
          label: val.namaClient,
        });
      });

    setListClient(tmp);
  }, [storeClient.listClient]);

  const getStatusUser = (statusUser) => {
    switch (statusUser) {
      case "tidak aktif":
        return {
          fontWeight: "bold",
          backgroundColor: "#F7DFE9",
          textColor: "#B0054B",
        };
      case "aktif":
        return {
          fontWeight: "bold",
          backgroundColor: "#E3EEF9",
          textColor: "#1569C7",
        };
      default:
        return {};
    }
  };

  const customStyles = {
    headRow: {
      style: {
        backgroundColor: "#F8F9FC",
        borderTop: "1px solid #E3E6F0",
      },
    },
    headCells: {
      style: {
        fontWeight: "800",
        fontSize: "13px",
        color: "#4E73DF",
        textTransform: "uppercase",
      },
    },
    rows: {
      style: {
        minHeight: "70px",
        "&:not(:last-child)": {
          borderBottom: "1px solid #E3E6F0",
        },
      },
    },
  };

  const colSalesMarketing = [
    {
      name: "No",
      width: "60px",
      center: true,
      selector: (row, index) => (currentPage - 1) * itemsPerPage + index + 1,
    },
    {
      name: "Nama & No Karyawan",
      minWidth: "250px",
      cell: (row) => (
        <div className="py-2">
          {/* Nama User */}
          <div
            className="text-dark mb-1"
            style={{ fontSize: "14px", fontWeight: "700" }}
          >
            {row.nama}
          </div>
          {/* Nopeg - Diperbesar & Tebal */}
          <div
            className="text-muted mb-1"
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#1D3557",
              letterSpacing: "0.5px",
            }}
          >
            {row.nopeg}
          </div>
        </div>
      ),
    },
    {
      name: "Kode User",
      minWidth: "120px",
      cell: (row) => (
        <span
          className="badge bg-light text-muted border px-2 py-1"
          style={{ fontSize: "12px", fontWeight: "600" }}
        >
          {row.kodeUser}
        </span>
      ),
    },
    {
      name: "Jabatan",
      minWidth: "220px",
      cell: (row) => {
        const isDirect = row.role !== "marketing";

        return (
          <div style={{ padding: "5px 0" }}>
            {/* Teks Jabatan Utama */}
            <div
              style={{
                fontSize: "13px",
                fontWeight: "800",
                color: isDirect ? "#1D3557" : "#5A6A85", // Navy untuk Direct, Grey-Blue untuk Reguler
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                lineHeight: "1.2",
              }}
            >
              {row.role === "marketing"
                ? "Sales Marketing"
                : "Direct Sales Marketing"}
            </div>

            {/* Garis aksen kecil di bawah untuk pembeda visual yang tipis */}
            <div
              style={{
                width: "25px",
                height: "3px",
                backgroundColor: isDirect ? "#F87171" : "#4E73DF", // Merah tipis untuk Direct, Biru untuk Reguler
                marginTop: "4px",
                borderRadius: "10px",
              }}
            ></div>
          </div>
        );
      },
    },
    {
      name: "Penempatan (BPD/Cabang)",
      minWidth: "250px",
      cell: (row) => {
        // Mengecek apakah ada data penempatan
        const hasPlacement =
          row.penempatan &&
          row.penempatan.length > 0 &&
          row.penempatan[0].namaCabang;

        return (
          <div className="py-2">
            {hasPlacement ? (
              <>
                {/* Tampilan Jika Sudah Ada Penempatan */}
                <div className="fw-bold text-dark" style={{ fontSize: "13px" }}>
                  <i className="fas fa-university mr-2 text-primary"></i>
                  {row.penempatan[0].namaClient}
                </div>
                <div className="text-muted" style={{ fontSize: "12px" }}>
                  <i className="fas fa-map-marker-alt mr-2 text-danger"></i>
                  <b>{row.penempatan[0].namaCabang}</b>
                </div>
              </>
            ) : (
              /* Tampilan Jika Belum Ada Penempatan (Sesuai Permintaan Anda) */
              <div
                className="d-flex align-items-center text-muted"
                style={{ fontStyle: "italic", fontSize: "13px" }}
              >
                <i className="fas fa-minus-circle mr-2 opacity-50"></i>
                Belum ada penempatan
              </div>
            )}
          </div>
        );
      },
    },
    {
      name: "Akses Marketing",
      minWidth: "180px",
      center: true,
      cell: (row) =>
        !row.kategoriMarketing ? (
          <span
            className="badge bg-soft-danger text-danger border border-danger px-2 py-1"
            style={{ fontSize: "11px" }}
          >
            BELUM ADA AKSES
          </span>
        ) : (
          <span
            className="badge bg-soft-primary text-primary border border-primary px-3 py-1 text-capitalize"
            style={{ fontSize: "12px" }}
          >
            <i className="fas fa-unlock-alt mr-1"></i> {row.kategoriMarketing}
          </span>
        ),
    },
    {
      name: "Aktivitas",
      minWidth: "180px",
      cell: (row) => (
        <div style={{ fontSize: "12px" }}>
          <div className="text-muted">Login Terakhir:</div>
          <div className="fw-bold text-dark">
            {row.loginDate
              ? moment(row.loginDate).format("DD MMM YYYY, HH:mm")
              : "-"}
          </div>
        </div>
      ),
    },
    {
      name: "Status",
      minWidth: "140px",
      center: true,
      cell: (row) => {
        const isActive = row.status === "aktif";
        return (
          <span
            style={{
              padding: "6px 12px",
              borderRadius: "20px",
              fontSize: "12px",
              fontWeight: "bold",
              backgroundColor: isActive ? "#D1FAE5" : "#FEE2E2",
              color: isActive ? "#065F46" : "#991B1B",
              display: "inline-flex",
              alignItems: "center",
            }}
          >
            <span
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: isActive ? "#10B981" : "#EF4444",
                marginRight: "8px",
              }}
            ></span>
            {isActive ? "Aktif" : "Tidak Aktif"}
          </span>
        );
      },
    },
    {
      name: "Aksi",
      minWidth: "250px",
      center: true,
      omit: !(auth.role === "super admin" || auth.role === "admin"),
      cell: (row) => row.action,
    },
  ];

  React.useEffect(() => {
    getAllMarketing(dispatch, { idClient: "" });
    getAllClient(dispatch);
  }, []);

  return (
    <>
      <Modal
        size="md"
        show={modalPenempatan || modalUbahPenempatan}
        onHide={() => {
          handleModalClose();
          setModalPenempatan(false);
          setModalUbahPenempatan(false);
        }}
        centered
        style={{ backdropFilter: "blur(5px)" }}
      >
        <Modal.Header closeButton className="border-0 bg-light" />
        <Modal.Body className="bg-light px-4 pb-4">
          <div className="text-center mb-4">
            <div
              style={{
                width: "70px",
                height: "70px",
                backgroundColor: "#1D3557",
                borderRadius: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 10px 20px rgba(29, 53, 87, 0.2)",
                marginBottom: "15px",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <i
                className={`fas ${modalUbahPenempatan ? "fa-map-pin" : "fa-map-marked-alt"} fa-2x text-white`}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>
            <h3 className="fw-800 text-dark mb-1">
              {modalUbahPenempatan ? "Ubah Penempatan" : "Form Penempatan"}
            </h3>
            <p className="text-muted">
              Tentukan cabang wilayah tugas untuk personil ini
            </p>
          </div>

          <Card className="border-0 shadow-sm" style={{ borderRadius: "20px" }}>
            <Card.Body className="p-4">
              <Form.Group className="mb-4">
                <label className="fw-bold text-dark mb-2">Pilih Cabang</label>
                <Select
                  classNamePrefix="react-select"
                  value={pilihCabang}
                  onChange={(value) => {
                    setPilihCabang(value);
                    setIdCabang(value.value);
                  }}
                  options={listCabang}
                  placeholder="Cari Cabang..."
                />
              </Form.Group>
              <Button
                className="btn-block p-3 text-white"
                style={{
                  border: "none",
                  backgroundColor: "#1D3557",
                  borderRadius: "15px",
                  fontWeight: "800",
                  boxShadow: "0 10px 20px rgba(29, 53, 87, 0.3)",
                }}
                onClick={
                  modalUbahPenempatan ? submitUbahPenempatan : submitPenempatan
                }
              >
                {modalUbahPenempatan
                  ? "UPDATE PENEMPATAN"
                  : "SIMPAN PENEMPATAN"}
              </Button>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>

      <Modal
        size="md"
        show={modalEdit}
        onHide={() => {
          setStatus("");
          setModalEdit(false);
        }}
        centered
        style={{ backdropFilter: "blur(5px)" }}
      >
        <Modal.Header closeButton className="border-0 bg-light" />
        <Modal.Body className="bg-light px-4 pb-4">
          <div className="text-center mb-4">
            <div
              style={{
                width: "70px",
                height: "70px",
                backgroundColor: "#1D3557",
                borderRadius: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 10px 20px rgba(29, 53, 87, 0.2)",
                marginBottom: "15px",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <i
                className="fas fa-user-shield fa-2x text-white"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>
            <h3 className="fw-800 text-dark mb-1">Edit Status Akun</h3>
            <p className="text-muted">Perbarui aktifasi akun marketing ini</p>
          </div>

          <Card className="border-0 shadow-sm" style={{ borderRadius: "20px" }}>
            <Card.Body className="p-4">
              <Form.Group className="mb-4">
                <label className="fw-bold text-dark mb-2">
                  Pilih Status Baru
                </label>
                <Select
                  classNamePrefix="react-select"
                  value={status}
                  onChange={(selectedOption) => setStatus(selectedOption)}
                  options={[
                    { value: "true", label: "Aktif" },
                    { value: "false", label: "Tidak Aktif" },
                  ]}
                  placeholder="Pilih Status..."
                />
              </Form.Group>
              <Button
                className="btn-block p-3 text-white"
                style={{
                  border: "none",
                  backgroundColor: "#1D3557",
                  borderRadius: "15px",
                  fontWeight: "800",
                  boxShadow: "0 10px 20px rgba(29, 53, 87, 0.3)",
                }}
                onClick={checkStatus}
              >
                SUBMIT PERUBAHAN
              </Button>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={salesMarketing}
        onHide={() => {
          handleModalClose();
          setSalesMarketing(false);
        }}
        centered
        style={{ backdropFilter: "blur(5px)" }}
      >
        <Modal.Header closeButton className="border-0 bg-light" />
        <Modal.Body className="bg-light px-4 pb-4">
          <div className="text-center mb-4">
            <div
              style={{
                width: "70px",
                height: "70px",
                backgroundColor: "#1D3557",
                borderRadius: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 10px 20px rgba(29, 53, 87, 0.2)",
                marginBottom: "15px",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <i
                className="fas fa-user-plus fa-2x text-white"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>
            <h3 className="fw-800 text-dark mb-1">Tambah Marketing</h3>
            <p className="text-muted">
              Daftarkan personil Sales/Direct Marketing baru
            </p>
          </div>

          <Card className="border-0 shadow-sm" style={{ borderRadius: "20px" }}>
            <Card.Body className="p-4">
              <Form>
                <Row>
                  <Col md="6" className="mb-3">
                    <Form.Group>
                      <label className="fw-bold text-dark mb-2">NIK</label>
                      <div className="position-relative">
                        <Form.Control
                          className="border-0 bg-light p-3"
                          style={{ borderRadius: "12px", fontWeight: "600" }}
                          onChange={handleNikChange}
                          value={nik}
                          type="text"
                          placeholder="Masukkan NIK"
                        />
                        <div
                          className="position-absolute fw-bold"
                          style={{
                            right: "15px",
                            top: "15px",
                            color: "#94a3b8",
                            fontSize: "12px",
                          }}
                        >
                          {remainingDigits} digit
                        </div>
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md="6" className="mb-3">
                    <Form.Group>
                      <label className="fw-bold text-dark mb-2">
                        Nama Lengkap
                      </label>
                      <Form.Control
                        className="border-0 bg-light p-3"
                        style={{ borderRadius: "12px", fontWeight: "600" }}
                        onChange={(e) => setNama(e.target.value)}
                        placeholder="Nama Lengkap"
                        type="text"
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6" className="mb-3">
                    <Form.Group>
                      <label className="fw-bold text-dark mb-2">
                        No Karyawan
                      </label>
                      <Form.Control
                        className="border-0 bg-light p-3"
                        style={{ borderRadius: "12px", fontWeight: "600" }}
                        onChange={(e) => setNopeg(e.target.value)}
                        placeholder="No Karyawan"
                        type="text"
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6" className="mb-3">
                    <Form.Group>
                      <label className="fw-bold text-dark mb-2">
                        Pilih Role
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        value={pilihRole}
                        onChange={(value) => {
                          setPilihRole(value);
                          setRole(value.value);
                        }}
                        options={[
                          { value: "marketing", label: "Sales Marketing" },
                          {
                            value: "direct marketing",
                            label: "Direct Marketing",
                          },
                        ]}
                        placeholder="Pilih Role"
                      />
                    </Form.Group>
                  </Col>
                  {auth.role === "super admin" && (
                    <Col md="12" className="mb-3">
                      <Form.Group>
                        <label className="fw-bold text-dark mb-2">
                          Pilih Client
                        </label>
                        <Select
                          classNamePrefix="react-select"
                          value={pilihClient}
                          onChange={(value) => {
                            setPilihClient(value);
                            setIdClient(value.value);
                          }}
                          options={listClient}
                          placeholder="Pilih Client"
                        />
                      </Form.Group>
                    </Col>
                  )}
                </Row>
                <Button
                  className="btn-block p-3 mt-4 text-white"
                  style={{
                    border: "none",
                    backgroundColor: "#1D3557",
                    borderRadius: "15px",
                    fontWeight: "800",
                    boxShadow: "0 10px 20px rgba(29, 53, 87, 0.3)",
                  }}
                  onClick={submitMarketing}
                >
                  SUBMIT DATA MARKETING
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={modalTambahAkses}
        onHide={() => {
          handleModalClose();
          setModalTambahAkses(false);
        }}
        centered
        style={{ backdropFilter: "blur(5px)" }}
      >
        <Modal.Header closeButton className="border-0 bg-light" />
        <Modal.Body className="bg-light px-4 pb-4">
          {/* HEADER SECTION DENGAN ICON NAVY */}
          <div className="text-center mb-4">
            <div
              style={{
                width: "70px",
                height: "70px",
                backgroundColor: "#1D3557",
                borderRadius: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 10px 20px rgba(29, 53, 87, 0.2)",
                marginBottom: "15px",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <i
                className="fas fa-user-lock fa-2x text-white"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>
            <h3 className="fw-800 text-dark mb-1">Manajemen Akses</h3>
            <p className="text-muted">
              Kelola hak akses kategori untuk personil marketing
            </p>
          </div>

          <Card className="border-0 shadow-sm" style={{ borderRadius: "20px" }}>
            <Card.Body className="p-4">
              {/* SECTION 1: FORM INPUT */}
              <Form>
                <Form.Group className="mb-4">
                  <label className="fw-bold text-dark mb-2">
                    <i className="fas fa-plus-circle mr-2 text-primary"></i>{" "}
                    Pilih Akses Baru
                  </label>

                  {/* Logic Select dengan Tooltip jika sudah ada akses */}
                  {aksesUser ? (
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip>
                          Setiap user hanya boleh memiliki satu akses utama.
                        </Tooltip>
                      }
                    >
                      <div style={{ cursor: "not-allowed" }}>
                        <Select
                          isDisabled={true}
                          classNamePrefix="react-select"
                          placeholder="Akses sudah terisi..."
                        />
                      </div>
                    </OverlayTrigger>
                  ) : (
                    <Select
                      classNamePrefix="react-select"
                      value={pilihAkses}
                      onChange={(value) => setPilihAkses(value)}
                      options={listAkses}
                      placeholder="Pilih Kategori Akses"
                    />
                  )}
                </Form.Group>

                <Button
                  className="btn-block p-3 text-white"
                  disabled={!pilihAkses || aksesUser}
                  style={{
                    border: "none",
                    backgroundColor:
                      !pilihAkses || aksesUser ? "#cbd5e1" : "#1D3557",
                    borderRadius: "15px",
                    fontWeight: "800",
                    boxShadow:
                      !pilihAkses || aksesUser
                        ? "none"
                        : "0 10px 20px rgba(29, 53, 87, 0.3)",
                    cursor:
                      !pilihAkses || aksesUser ? "not-allowed" : "pointer",
                  }}
                  onClick={submitTambahAksesUser}
                >
                  <i className="fas fa-save mr-2"></i> SIMPAN AKSES USER
                </Button>
              </Form>

              <hr className="my-4" />

              {/* SECTION 2: DAFTAR AKSES AKTIF */}
              <div className="bg-light p-3" style={{ borderRadius: "15px" }}>
                <h6 className="fw-bold text-dark mb-3">
                  <i className="fas fa-id-badge mr-2 text-primary"></i> Akses
                  Saat Ini:
                </h6>

                {!aksesUser ? (
                  <div className="text-danger fw-bold italic py-2">
                    <i className="fas fa-exclamation-triangle mr-2"></i> User
                    ini belum memiliki akses.
                  </div>
                ) : (
                  <div
                    className="d-flex align-items-center justify-content-between p-3 bg-white shadow-sm"
                    style={{
                      borderRadius: "12px",
                      border: "1px solid #e2e8f0",
                    }}
                  >
                    <div>
                      <span
                        className="badge bg-soft-primary text-primary px-3 py-2 text-capitalize"
                        style={{ fontSize: "14px", fontWeight: "700" }}
                      >
                        {aksesUser}
                      </span>
                    </div>

                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip>Hapus Akses</Tooltip>}
                    >
                      <Button
                        className="d-flex align-items-center justify-content-center shadow-sm"
                        style={{
                          backgroundColor: "#EF4444",
                          width: "35px",
                          height: "35px",
                          borderRadius: "8px",
                          border: 0,
                        }}
                        onClick={() => {
                          Swal.fire({
                            icon: "warning",
                            title: "Hapus Akses?",
                            html: `Yakin ingin menghapus akses <b class="text-primary text-capitalize">${aksesUser}</b>?`,
                            showCancelButton: true,
                            confirmButtonText: "Ya, Hapus",
                            cancelButtonText: "Batal",
                            confirmButtonColor: "#EF4444",
                          }).then((result) => {
                            if (result.isConfirmed) {
                              hapusAksesUser({
                                idMarketing,
                                kategoriMarketing: aksesUser,
                              }).then((response) => {
                                if (response.status === 200) {
                                  Swal.fire({
                                    icon: "success",
                                    title: "Berhasil Dihapus",
                                    showConfirmButton: false,
                                    timer: 1000,
                                  });
                                  handleModalClose();
                                  getAllMarketing(dispatch, { idClient: "" });
                                }
                              });
                            }
                          });
                        }}
                      >
                        <i className="fas fa-trash text-white"></i>
                      </Button>
                    </OverlayTrigger>
                  </div>
                )}
              </div>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>

      <Tab.Content className="mt-3">
        <Card className="border-0 bg-transparent">
          {/* Header Section: Flexbox Responsive */}
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-4">
            {/* Tombol Tambah di Kiri */}
            <div className="mb-3 mb-md-0">
              {(auth.role === "super admin" || auth.role === "admin") && (
                <Button
                  onClick={() => setSalesMarketing(!salesMarketing)}
                  className="btn-fill d-flex align-items-center shadow-sm"
                  style={{
                    backgroundColor: "#1D3557", // Navy konsisten
                    border: "none",
                    borderRadius: "10px",
                    padding: "10px 24px",
                    fontWeight: "600",
                    transition: "all 0.3s ease",
                  }}
                >
                  <i
                    className="nc-icon nc-simple-add mr-2"
                    style={{ fontSize: "1.1rem" }}
                  ></i>
                  <span>Tambah Marketing</span>
                </Button>
              )}
            </div>

            {/* Search Bar di Kanan */}
            <div style={{ width: "100%", maxWidth: "350px" }}>
              <InputGroup
                className="shadow-sm"
                style={{
                  borderRadius: "10px",
                  overflow: "hidden",
                  border: "1px solid #ced4da",
                }}
              >
                <InputGroup.Prepend>
                  <InputGroup.Text
                    className="border-0"
                    style={{ backgroundColor: "#f8f9fa" }}
                  >
                    <i className="nc-icon nc-zoom-split text-dark fw-bold"></i>
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  className="border-0 ps-1"
                  type="text"
                  value={searchText}
                  onChange={handleSearch}
                  placeholder="No. Karyawan / Nama Marketing..."
                  style={{
                    height: "45px",
                    backgroundColor: "#f8f9fa",
                    boxShadow: "none",
                    fontSize: "0.95rem",
                  }}
                />
              </InputGroup>
            </div>
          </div>
        </Card>
      </Tab.Content>

      {/* Tabel Section */}
      <Card
        className="border-0 shadow-sm overflow-hidden"
        style={{ borderRadius: "15px" }}
      >
        <DataTable
          columns={colSalesMarketing}
          data={listMarketing.filter(
            (row) =>
              row.nama.toLowerCase().includes(searchText.toLowerCase()) ||
              row.nopeg.toLowerCase().includes(searchText.toLowerCase()),
          )}
          customStyles={customStyles}
          pagination
          paginationRowsPerPageOptions={[10, 25, 50, 75, 100]}
          paginationPerPage={itemsPerPage}
          onChangePage={handlePageChange}
          highlightOnHover
          responsive
        />
      </Card>
    </>
  );
}
export default ListMarketing;
